(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2550],{

/***/ 84790:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/[storyId]",
      function () {
        return __webpack_require__(29781);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0;\n\n  .kakao_ad_loaded {\n    box-sizing: content-box;\n    border-top: 8px solid ",
        ";\n    border-bottom: 8px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var adfitCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), theme.border.space, theme.border.space);
};
var Adfit = function(param) {
    var _type = param.type, type = _type === void 0 ? "default" : _type;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var insRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var adIds = {
        default: "DAN-qr8EQ7sjZsy3CDqq",
        story: "DAN-zgHG6SftJMliFZSC",
        library: "DAN-5TSBCtHd9kOfJvtE",
        episodeEnding: "DAN-46N5zb9cg50PxRee"
    };
    // Intersection Observer: 뷰포트 진입 시에만 광고 로드
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!containerRef.current) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = _slicedToArray(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "200px"
        });
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, []);
    // 뷰포트 진입 후 AdFit 스크립트 로드
    var loadAdfit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (!isVisible) return;
        var existing = document.querySelector('script[src*="t1.daumcdn.net/kas/static/ba.min.js"]');
        if (!existing) {
            var script = document.createElement("script");
            script.src = "//t1.daumcdn.net/kas/static/ba.min.js";
            script.async = true;
            script.type = "text/javascript";
            document.body.appendChild(script);
        } else {
            // 스크립트가 이미 있으면 AdFit 재호출
            if (window.adfit && typeof window.adfit === "function") {
                window.adfit("create", {
                    adUnitId: adIds[type],
                    containerElement: insRef.current
                });
            }
        }
    }, [
        isVisible,
        type
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        loadAdfit();
    }, [
        loadAdfit
    ]);
    // MutationObserver: 광고 로드 완료 감지
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!insRef.current || !isVisible) return;
        var observer = new MutationObserver(function() {
            if (insRef.current) {
                insRef.current.className = "kakao_ad_loaded";
                observer.disconnect();
            }
        });
        observer.observe(insRef.current, {
            attributes: true,
            attributeFilter: [
                "style"
            ]
        });
        return function() {
            observer.disconnect();
        };
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        ref: containerRef,
        css: adfitCSS,
        children: isVisible && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ins", {
            ref: insRef,
            className: "kakao_ad_area",
            style: {
                display: "none"
            },
            "data-ad-unit": adIds[type],
            "data-ad-width": "320",
            "data-ad-height": "50"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Adfit);


/***/ }),

/***/ 67705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var _components_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38945);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30259);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81946);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  padding: ",
        "px;\n  text-align: center;\n  gap: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 48px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  white-space: pre-line;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var containerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xlarge */ .Ki.xlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium);
var emojiCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject1());
var titleCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject2(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Typography.h5 */ .ZT.h5);
var descCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject3(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Typography.body14 */ .ZT.body14);
var AdultContentBlocker = function(param) {
    var needsLogin = param.needsLogin, needsCertification = param.needsCertification, isLoading = param.isLoading, children = param.children;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_4__/* .useGlobalContext */ .bN)().platform;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_5__/* .useWebView */ .B9)().web;
    if (isLoading) {
        return null;
    }
    if (!needsLogin && !needsCertification) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
            children: children
        });
    }
    var handleLogin = function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_3__/* .Platform.web */ .t4.web) {
            window.location.href = "/signin";
        } else {
            window.parent.postMessage({
                type: "NotAuthenticated"
            }, "*");
        }
    };
    var handleCertification = function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_3__/* .Platform.web */ .t4.web) {
            // 웹에서는 앱 다운로드 유도 또는 인증 페이지로
            web.openMarket();
        } else {
            window.parent.postMessage({
                type: "AC"
            }, "*");
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        css: containerCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
                css: emojiCSS,
                children: "\uD83D\uDD1E"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
                css: titleCSS,
                children: needsLogin ? t("로그인이 필요해요") : t("성인인증이 필요해요")
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
                css: descCSS,
                children: needsLogin ? t("19세 이상만 이용 가능한 콘텐츠입니다.\n로그인 후 이용해 주세요.") : t("19세 이상만 이용 가능한 콘텐츠입니다.\n성인인증 후 이용해 주세요.")
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                onClick: needsLogin ? handleLogin : handleCertification,
                children: needsLogin ? t("로그인") : t("성인인증 하기")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdultContentBlocker);


/***/ }),

/***/ 10379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    list-style-type: none;\n    font-size: ",
        "px;\n    padding-left: ",
        "px;\n\n    li + li {\n      margin-top: ",
        "px;\n    }\n\n    li {\n      position: relative;\n\n      p {\n        word-break: keep-all;\n      }\n\n      &:before {\n        content: '\xb7';\n        position: absolute;\n        top: -1px;\n        left: -12px;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var listCSS = function(fontSize, margin) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), fontSize, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, margin);
};
var _obj;
var DottedListSize = (_obj = {}, _defineProperty(_obj, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Sizes.small */ .u8.small, {
    fontSize: chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .FontSizes.xsmall */ .TS.xsmall,
    margin: chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xxsmall */ .Ki.xxsmall
}), _defineProperty(_obj, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Sizes.medium */ .u8.medium, {
    fontSize: chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .FontSizes.small */ .TS.small,
    margin: chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xhsmall */ .Ki.xhsmall
}), _obj);
var DottedList = function(param) {
    var className = param.className, items = param.items, _size = param.size, size = _size === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Sizes.medium */ .u8.medium : _size;
    var _size1 = DottedListSize[size], fontSize = _size1.fontSize, margin = _size1.margin;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
        css: listCSS(fontSize, margin),
        className: className,
        children: items.map(function(item, i) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                        className: "dot"
                    }),
                    typeof item === "string" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                        className: "multiline",
                        children: item
                    }) : item
                ]
            }, "dotted-list-".concat(i));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DottedList);


/***/ }),

/***/ 61507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77814);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  button {\n    font-size: ",
        "px;\n    color: ",
        ";\n\n    &.active {\n      color: ",
        ";\n    }\n  }\n\n  span {\n    display: inline-block;\n    height: 12px;\n    border-left: 1px solid ",
        ";\n    margin: 0 ",
        "px;\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var horizontalFilterCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .FontSizes.xsmall */ .TS.xsmall, theme.var.gray500, theme.var.black, theme.border.light, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xsmall */ .Ki.xsmall);
};
var HorizontalFilter = function(param) {
    var options = param.options, selected = param.selected, onChange = param.onChange;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        css: horizontalFilterCSS,
        children: options.map(function(option, i) {
            /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    i > 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("button", {
                        onClick: function() {
                            return onChange === null || onChange === void 0 ? void 0 : onChange(option.value);
                        },
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(option.value === selected ? "active" : undefined, "text-btn"),
                        children: option.label
                    })
                ]
            }, "horizontal-filter-".concat(option.value));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HorizontalFilter);


/***/ }),

/***/ 80521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0;\n  height: 0;\n  overflow: hidden;\n\n  &.adsense-loaded {\n    height: auto;\n    border-top: 8px solid ",
        ";\n    border-bottom: 8px solid ",
        ";\n  }\n\n  &.adsense-failed {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 11px;\n  color: ",
        ";\n  padding: 4px 12px 0;\n  line-height: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px;\n  background: ",
        ";\n  border: 1px dashed ",
        ";\n  border-radius: 8px;\n  margin: 4px 0;\n\n  .dev-ad-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 8px;\n    background: linear-gradient(\n      135deg,\n      ",
        ",\n      ",
        "\n    );\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n  }\n\n  .dev-ad-content {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .dev-ad-label {\n    font-size: 10px;\n    color: ",
        ";\n    margin-bottom: 2px;\n  }\n\n  .dev-ad-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: ",
        ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .dev-ad-body {\n    font-size: 12px;\n    color: ",
        ";\n    margin-top: 2px;\n  }\n\n  .dev-ad-cta {\n    font-size: 11px;\n    font-weight: 600;\n    color: white;\n    background: ",
        ";\n    border: none;\n    border-radius: 14px;\n    padding: 6px 14px;\n    flex-shrink: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var containerCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), theme.border.space, theme.border.space);
};
var adLabelCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), theme.var.gray400);
};
var devPreviewCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject2(), theme.var.gray50, theme.var.gray300, theme.var.gray200, theme.var.gray300, theme.var.gray400, theme.var.gray700, theme.var.gray500, theme.colors.main500);
};
var AD_UNITS = {
    home_cp_mobile: {
        slot: "1147096797" || 0,
        layoutKey: "-7t+er-i-q+3d" || 0
    },
    home_sr_mobile: {
        slot: "5407973686" || 0,
        layoutKey: "-hj" || 0
    },
    feed_default_mobile: {
        slot: "9380810036" || 0,
        layoutKey: "-fl+5f+76-cs-1m" || 0
    },
    library_mobile: {
        slot: "5316474349" || 0,
        layoutKey: "-bl+bt-3y-7x+tm" || 0
    },
    story_mobile: {
        slot: "9181499480" || 0,
        layoutKey: "-fj+65+1s-bv+er" || 0
    },
    episode_mobile: {
        slot: "8798356107" || 0,
        layoutKey: "-b5+bp-3d-6j+ow" || 0
    }
};
var ADSENSE_CLIENT = "";
var IS_DEV = !!ADSENSE_CLIENT && "object" !== "undefined" && window.location.hostname === "localhost";
// 스크립트 중복 삽입 방지용 모듈 스코프 플래그
var adsenseScriptState = "idle";
var adsenseLoadCallbacks = [];
var NativeInFeedAd = function(param) {
    var unitKey = param.unitKey;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var insRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var pushedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var adUnit = AD_UNITS[unitKey];
    var isEnabled = !!(ADSENSE_CLIENT && (adUnit === null || adUnit === void 0 ? void 0 : adUnit.slot));
    // IntersectionObserver: 뷰포트 200px 이내 진입 시 로드
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isEnabled && !IS_DEV || !containerRef.current) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = _slicedToArray(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "200px"
        });
        observer.observe(containerRef.current);
        return function() {
            return observer.disconnect();
        };
    }, [
        isEnabled
    ]);
    // AdSense 스크립트 로드 + push
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isEnabled || !isVisible || pushedRef.current || IS_DEV) return;
        var pushAd = function() {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
                pushedRef.current = true;
            } catch (e) {
                console.warn("[AdSense InFeed] push error:", e);
            }
        };
        if (adsenseScriptState === "loaded") {
            pushAd();
            return;
        }
        if (adsenseScriptState === "loading") {
            adsenseLoadCallbacks.push(pushAd);
            return;
        }
        // 최초 1회 스크립트 삽입
        adsenseScriptState = "loading";
        adsenseLoadCallbacks.push(pushAd);
        var script = document.createElement("script");
        script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=".concat(ADSENSE_CLIENT);
        script.async = true;
        script.crossOrigin = "anonymous";
        script.onload = function() {
            adsenseScriptState = "loaded";
            adsenseLoadCallbacks.forEach(function(cb) {
                return cb();
            });
            adsenseLoadCallbacks.length = 0;
        };
        script.onerror = function() {
            adsenseScriptState = "idle";
            adsenseLoadCallbacks.length = 0;
            console.warn("[AdSense InFeed] script load failed");
        };
        document.head.appendChild(script);
    }, [
        isEnabled,
        isVisible
    ]);
    // 로드 완료 감지 + 타임아웃 시 숨김
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!insRef.current || !isVisible || IS_DEV) return;
        var loaded = false;
        var observer = new MutationObserver(function() {
            if (insRef.current && insRef.current.childElementCount > 0 && containerRef.current) {
                loaded = true;
                containerRef.current.classList.add("adsense-loaded");
                observer.disconnect();
            }
        });
        observer.observe(insRef.current, {
            childList: true,
            subtree: true
        });
        // 5초 내 로드 안 되면 숨김
        var timeout = setTimeout(function() {
            if (!loaded && containerRef.current) {
                containerRef.current.classList.add("adsense-failed");
                observer.disconnect();
            }
        }, 5000);
        return function() {
            observer.disconnect();
            clearTimeout(timeout);
        };
    }, [
        isVisible
    ]);
    if (!isEnabled && !IS_DEV) return null;
    // 로컬 개발 환경: 미리보기 플레이스홀더
    if (IS_DEV) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            ref: containerRef,
            css: devPreviewCSS,
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                    className: "dev-ad-icon",
                    children: "AD"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                    className: "dev-ad-content",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                            className: "dev-ad-label",
                            children: [
                                "AdSense InFeed \xb7 ",
                                unitKey
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                            className: "dev-ad-title",
                            children: "광고 제목이 여기에 표시됩니다"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                            className: "dev-ad-body",
                            children: "광고 설명 텍스트 미리보기"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
                    type: "button",
                    className: "dev-ad-cta",
                    children: "자세히"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        ref: containerRef,
        css: containerCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                css: adLabelCSS,
                children: "광고"
            }),
            isVisible && adUnit && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ins", {
                ref: insRef,
                className: "adsbygoogle",
                style: {
                    display: "block"
                },
                "data-ad-format": "fluid",
                "data-ad-layout-key": adUnit.layoutKey,
                "data-ad-client": ADSENSE_CLIENT,
                "data-ad-slot": adUnit.slot
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NativeInFeedAd);


/***/ }),

/***/ 59953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8683);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var _Present_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21784);
/* harmony import */ var _Present_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Present_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-explicit-any */ function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}



var StorySnow = function() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        (function() {
            var init = function init() {
                snowflakes = [];
                resize();
                render(lastNow = performance.now());
            };
            var resume = function resume() {
                lastNow = performance.now();
                requestAnimationFrame(render);
            };
            var resize = function resize() {
                width = canvas.width;
                height = canvas.height;
                maxSnowflakes = Math.max(width / 10, 100);
            };
            var cleanup = function cleanup() {
                // Cleanup function to cancel the animation frame and hide the canvas
                if (canvas) {
                    canvas.style.display = "none"; // Hide the canvas when unmounted
                }
            };
            var canvas = document.getElementById("present-canvas");
            var ctx = canvas === null || canvas === void 0 ? void 0 : canvas.getContext("2d");
            if (!ctx) {
                return;
            }
            var width, height, lastNow;
            var snowflakes;
            var maxSnowflakes = 100;
            function render(now) {
                requestAnimationFrame(render);
                if (!ctx) {
                    return;
                }
                var elapsed = now - lastNow;
                lastNow = now;
                ctx === null || ctx === void 0 ? void 0 : ctx.clearRect(0, 0, width, height);
                if (snowflakes.length < maxSnowflakes) snowflakes.push(new Snowflake());
                ctx.fillStyle = ctx.strokeStyle = "rgba(255, 255, 255, .5)";
                snowflakes.forEach(function(snowflake) {
                    return snowflake.update(elapsed, now);
                });
            }
            var Snowflake = /*#__PURE__*/ function() {
                "use strict";
                function Snowflake() {
                    _classCallCheck(this, Snowflake);
                    this.spawn();
                }
                var _proto = Snowflake.prototype;
                _proto.spawn = function spawn() {
                    var anyY = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    this.x = rand(0, width);
                    this.y = anyY === true ? rand(-50, height + 50) : rand(-50, -10);
                    this.xVel = rand(-0.05, 0.05);
                    this.yVel = rand(0.02, 0.1);
                    this.angle = rand(0, Math.PI * 2);
                    this.angleVel = rand(-0.001, 0.001);
                    this.size = rand(7, 12);
                    this.sizeOsc = rand(0.01, 0.5);
                };
                _proto.update = function update(elapsed, now) {
                    var xForce = rand(-0.001, 0.001);
                    if (Math.abs(this.xVel + xForce) < 0.075) {
                        this.xVel += xForce;
                    }
                    this.x += this.xVel * elapsed;
                    this.y += this.yVel * elapsed;
                    this.angle += this.xVel * 0.05 * elapsed; //this.angleVel * elapsed
                    if (this.y - this.size > height || this.x + this.size < 0 || this.x - this.size > width) {
                        this.spawn();
                    }
                    this.render();
                };
                _proto.render = function render() {
                    if (!ctx) {
                        return;
                    }
                    ctx.save();
                    var ref = this, x = ref.x, y = ref.y, angle = ref.angle, size = ref.size;
                    ctx.beginPath();
                    ctx.arc(x, y, size * 0.2, 0, Math.PI * 2, false);
                    ctx.fill();
                    ctx.restore();
                };
                return Snowflake;
            }();
            // Utils
            var rand = function(min, max) {
                return min + Math.random() * (max - min);
            };
            window.addEventListener("resize", resize);
            window.addEventListener("focus", resume);
            init();
            return cleanup;
        })();
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("canvas", {
            className: (_Present_module_css__WEBPACK_IMPORTED_MODULE_2___default()["canvas-story"]),
            id: "present-canvas"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StorySnow);


/***/ }),

/***/ 8181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ FloatingButton; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96964);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  right: ",
        "px;\n  bottom: 0;\n  z-index: 8;\n  ",
        ";\n\n  > div {\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    padding: ",
        "px;\n    background-color: ",
        ";\n    font-size: 0;\n    border-radius: 50%;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var floatingButtonAreaCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium));
var FloatingButtonArea = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        css: floatingButtonAreaCSS,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FloatingButtonArea);
var floatingButtonCSS = function(color) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.small */ .Ki.small + 2, color !== null && color !== void 0 ? color : theme.colors.main400);
    };
};
var FloatingButton = function(param) {
    var color = param.color, children = param.children, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("button", {
        css: floatingButtonCSS(color),
        onClick: onClick,
        children: children
    });
};


/***/ }),

/***/ 6668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74001);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  max-height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var _SKELETON_LIST = _toConsumableArray(new Array(10).keys());
var skeletonListCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject());
var SkeletonList = function(param) {
    var Skeleton = param.skeleton;
    var ref = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_2__/* .useInView */ .YD)(), inView = ref.inView, ref1 = ref.ref, entry = ref.entry;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), skeletonHeight = ref2[0], setSkeletonHeight = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (inView && entry) {
            setSkeletonHeight(window.innerHeight - entry.boundingClientRect.top);
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        css: skeletonListCSS,
        ref: ref1,
        style: skeletonHeight ? {
            height: skeletonHeight
        } : undefined,
        children: _SKELETON_LIST.map(function(i) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Skeleton, {}, "skeleton-".concat(i));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonList);


/***/ }),

/***/ 15872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71618);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _layout_FloatingButtonArea__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8181);





var DonationButton = function(param) {
    var onClick = param.onClick;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_FloatingButtonArea__WEBPACK_IMPORTED_MODULE_2__/* .FloatingButton */ .T, {
        onClick: onClick,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
            icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .DoubleBalloon */ .P$,
            size: chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Sizes.large */ .u8.large,
            color: theme.true.white
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DonationButton);


/***/ }),

/***/ 95151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _stores_useToastStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23961);

var useToast = function() {
    var ref = (0,_stores_useToastStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(state) {
        return state;
    }), showToast = ref.addToastList, hideAllToast = ref.clearAllToastList;
    return {
        showToast: showToast,
        hideAllToast: hideAllToast
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useToast);


/***/ }),

/***/ 29781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _storyId_; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(92926);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/head.js
var head = __webpack_require__(83289);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-query-virtual-8f3bd3534b/0/cache/react-query-npm-3.39.3-72b2a93edf-d2de6a0992.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(54909);
// EXTERNAL MODULE: ./hooks/query/useStoryQuery.ts
var useStoryQuery = __webpack_require__(6330);
// EXTERNAL MODULE: ./hooks/useBroadcastChannel.ts
var useBroadcastChannel = __webpack_require__(41785);
// EXTERNAL MODULE: ./hooks/useModal.ts
var useModal = __webpack_require__(48294);
// EXTERNAL MODULE: ./hooks/useScrollPosition.ts
var useScrollPosition = __webpack_require__(80786);
// EXTERNAL MODULE: ./hooks/useToast.ts
var useToast = __webpack_require__(95151);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
// EXTERNAL MODULE: ./.yarn/cache/date-fns-npm-2.30.0-895c790e0f-f7be015232.zip/node_modules/date-fns/esm/minutesToMilliseconds/index.js
var minutesToMilliseconds = __webpack_require__(72218);
// EXTERNAL MODULE: ./components/common/Avatar.tsx
var Avatar = __webpack_require__(81649);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(39854);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(3263);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
;// CONCATENATED MODULE: ./components/characters/CharacterDetailCta.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 8px ",
        "px 12px;\n  gap: 12px;\n\n  ",
        " {\n    padding: 8px ",
        "px 12px;\n  }\n  ",
        " {\n    padding: 8px ",
        "px 12px;\n  }\n\n  .title {\n    ",
        "\n  }\n\n  .shadow {\n    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);\n    border-radius: ",
        "px;\n  }\n\n  .btn {\n    position: relative;\n    padding: 12px;\n  }\n  .btn::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: ",
        "px;\n    padding: 1px;\n    background: linear-gradient(56.96deg, #04c8d0 19.7%, #1590d4 80.3%);\n    -webkit-mask: linear-gradient(#fff 0 0) content-box,\n      linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n  }\n  .content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n  }\n  .profile {\n    display: flex;\n    gap: 12px;\n    flex: 1;\n  }\n\n  .text {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    justify-content: center;\n    gap: 4px;\n\n    color: ",
        ";\n    ",
        ";\n\n    h5 {\n      color: ",
        ";\n      ",
        "\n      white-space: wrap;\n      ",
        ";\n    }\n    p {\n      white-space: wrap;\n      ",
        ";\n    }\n  }\n\n  .arrow {\n    display: flex;\n    align-items: center;\n    ",
        ";\n    gap: 4px;\n    background: linear-gradient(56.96deg, #04c8d0 19.7%, #1590d4 80.3%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var containerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Typography.h6 */.ZT.h6, dist_esm/* Radius.small */.wU.small, dist_esm/* Radius.small */.wU.small, theme.var.gray800, dist_esm/* Typography.body14_sentence */.ZT.body14_sentence, theme.var.gray900, dist_esm/* Typography.h5 */.ZT.h5, (0,css/* multilineEllipsis */.Zy)(1), (0,css/* multilineEllipsis */.Zy)(1), dist_esm/* Typography.h5 */.ZT.h5);
};
var CharacterDetailCta = function(param) {
    var _titleText = param.titleText, titleText = _titleText === void 0 ? "성격만 보면 최애 확정\uD83D\uDD25" : _titleText, character = param.character;
    var router = (0,next_router.useRouter)();
    var web = (0,webview/* useWebView */.B9)().web;
    var platform = (0,global/* useGlobalContext */.bN)().platform;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var handleNavigateDetail = function() {
        firebase.logEvent("story_character_click", {
            character_id: character.id,
            story_id: character.story_id
        });
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/".concat(character.id));
            return;
        }
        web.openPage("/play/characters/".concat(character.id));
    };
    (0,react.useEffect)(function() {
        (0,misc/* setFlow */.kB)({
            name: "CTA"
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: containerCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                className: "title",
                children: titleText
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: "shadow",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "btn",
                    onClick: handleNavigateDetail,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                className: "profile",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Avatar/* default */.ZP, {
                                        size: Avatar/* AvatarSize.largeSquare */.DZ.largeSquare,
                                        picture: character.profile_image
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        className: "text",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                                                children: character.name
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                className: "multiline",
                                                children: "".concat(character.information.age, "세 | ").concat(character.information.job)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                className: "arrow",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                                        children: "프로필 보기"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                        icon: icon/* ArrowRight */.ol,
                                        size: dist_esm/* Sizes.xsmall */.u8.xsmall,
                                        color: "rgba(21, 144, 212, 1)"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var characters_CharacterDetailCta = (CharacterDetailCta);

// EXTERNAL MODULE: ./components/common/ActionSheet.tsx
var ActionSheet = __webpack_require__(83898);
// EXTERNAL MODULE: ./components/common/Adfit.tsx
var Adfit = __webpack_require__(15822);
// EXTERNAL MODULE: ./components/common/AdultContentBlocker.tsx
var AdultContentBlocker = __webpack_require__(67705);
// EXTERNAL MODULE: ./components/common/Badge.tsx
var Badge = __webpack_require__(63732);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(38945);
// EXTERNAL MODULE: ./components/common/EFinderImage.tsx
var EFinderImage = __webpack_require__(11247);
// EXTERNAL MODULE: ./components/common/ListItem.tsx
var ListItem = __webpack_require__(92626);
// EXTERNAL MODULE: ./components/common/Seo.tsx
var Seo = __webpack_require__(14054);
// EXTERNAL MODULE: ./components/common/Tag.tsx
var Tag = __webpack_require__(22252);
// EXTERNAL MODULE: ./components/events/StorySnow.tsx
var StorySnow = __webpack_require__(59953);
// EXTERNAL MODULE: ./components/layout/Border.tsx
var Border = __webpack_require__(95567);
// EXTERNAL MODULE: ./components/layout/FloatingButtonArea.tsx
var FloatingButtonArea = __webpack_require__(8181);
// EXTERNAL MODULE: ./components/layout/Header.tsx + 1 modules
var Header = __webpack_require__(58761);
// EXTERNAL MODULE: ./components/layout/Layout.tsx
var Layout = __webpack_require__(26382);
// EXTERNAL MODULE: ./components/layout/Pad.tsx
var Pad = __webpack_require__(95833);
// EXTERNAL MODULE: ./components/layout/Push.tsx
var Push = __webpack_require__(23516);
// EXTERNAL MODULE: ./components/layout/SafeArea.tsx
var SafeArea = __webpack_require__(45861);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/index.js + 4 modules
var components_form = __webpack_require__(61527);
;// CONCATENATED MODULE: ./public/images/appReview/star_active.png
/* harmony default export */ var star_active = ({"src":"https://mn.chatie.me/assets/8e774a4b1499c8356f38cb4b0007043a0c52e9e6/_next/static/media/star_active.6fa3a866.png","height":78,"width":80,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEX901NMaXH901T901T901T901T901T901T901Rk2mV1AAAACXRSTlP/AHWoXAfkijaxPXyyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVQImR2GiQ3AMBCDwL48+09cpUgIcJm4RN1bZVJohvJTPK9HvG+uGFoizvj8ABIbAH8uP0hmAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/appReview/star_inactive.png
/* harmony default export */ var star_inactive = ({"src":"https://mn.chatie.me/assets/8e774a4b1499c8356f38cb4b0007043a0c52e9e6/_next/static/media/star_inactive.bc364889.png","height":78,"width":80,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEXv7+9MaXHv7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+92OkfHAAAACnRSTlP/AHVcqwfkoYo23KjqFgAAAAlwSFlzAAALEwAACxMBAJqcGAAAADBJREFUCJkdhokJAEEMhHSS/fpv+MgJorhMXKLurVJp6BSHn4N3esU388TQTcQqxw8T1ACJAamCqgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./api/common.ts
var common = __webpack_require__(98379);
// EXTERNAL MODULE: ./utils/form.ts
var utils_form = __webpack_require__(57585);
// EXTERNAL MODULE: ./utils/localStorage.ts
var localStorage = __webpack_require__(48163);
// EXTERNAL MODULE: ./components/common/Image.tsx
var Image = __webpack_require__(85496);
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(59585);
;// CONCATENATED MODULE: ./components/modal/AppReviewModal.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function AppReviewModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function AppReviewModal_templateObject() {
    var data = AppReviewModal_taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    AppReviewModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = AppReviewModal_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  margin-top: ",
        "px;\n\n  button + button {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



















var ratingDescriptionCSS = (0,emotion_react_browser_esm.css)(AppReviewModal_templateObject());
var ratingCSS = (0,emotion_react_browser_esm.css)(_templateObject1(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.xsmall */.Ki.xsmall);
var AppReviewModal = function(props) {
    var onClose = props.onClose;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,webview/* useWebView */.B9)(), web = ref.web, listen = ref.listen;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var ref1 = (0,react.useState)("rating"), view = ref1[0], setView = ref1[1];
    var ref2 = (0,es.useMutation)(function(payload) {
        return (0,common/* postReasons */.DS)(constants/* UniversalReason.appReview */.D2.appReview, payload);
    }), submitFeedback = ref2.mutate;
    var ref3 = (0,utils_form/* useForm */.c)({
        rating: 0,
        reason: ""
    }, {
        validator: function(values) {
            var reason = values.reason.trim();
            if (!reason) {
                return [
                    false,
                    t("내용을 입력해주세요.")
                ];
            }
            return [
                true,
                undefined
            ];
        },
        onSubmit: function(done) {
            submitFeedback(values, {
                onSuccess: function() {
                    alert(t("소중한 의견 감사합니다!"));
                    onClose();
                },
                onSettled: done
            });
        }
    }), values = ref3.values, onChange = ref3.onChange, setValue = ref3.setValue, isSubmitting = ref3.isSubmitting, isValidated = ref3.isValidated, submit = ref3.submit;
    var handleRating = (0,react.useCallback)(function() {
        if (values.rating === 0) {
            alert(t("평가를 입력해주세요."));
            return;
        }
        if (values.rating > 3) {
            web.showAppReview();
        } else {
            setView("feedback");
        }
    }, [
        values.rating
    ]);
    var review = (0,react.useCallback)(function(answer) {
        var day = 1000 * 60 * 60 * 24;
        var minute = 1000 * 60;
        var now = new Date().getTime();
        var isProduction = (0,misc/* isEnv */.h5)("production");
        switch(answer){
            case "yes":
                {
                    var disableDays = isProduction ? day * 365 : minute * 60;
                    localStorage/* ParsedStorage.setItem */.f.setItem("hideAppReviewUntil", now + disableDays);
                    break;
                }
            case "no":
                {
                    var disableDays1 = isProduction ? day * 15 : minute * 15;
                    localStorage/* ParsedStorage.setItem */.f.setItem("hideAppReviewUntil", now + disableDays1);
                    break;
                }
            case "later":
                {
                    var disableDays2 = isProduction ? day * 7 : minute * 3;
                    localStorage/* ParsedStorage.setItem */.f.setItem("hideAppReviewUntil", now + disableDays2);
                    break;
                }
            case "far_later":
                {
                    var disableDays3 = isProduction ? day * 90 : minute * 5;
                    localStorage/* ParsedStorage.setItem */.f.setItem("hideAppReviewUntil", now + disableDays3);
                }
            default:
                break;
        }
        firebase.logEvent("app_review", {
            answer: answer
        });
        onClose();
    }, []);
    // 앱 리뷰 리스너
    (0,react.useEffect)(function() {
        var unlisten = listen("induceAppReview", function(e) {
            var value = e.detail.value;
            if (value === 0) {
                review("no");
            } else if (value === 1) {
                review("later");
            } else {
                review("yes");
            }
        });
        return unlisten;
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* default */.ZP, _objectSpreadProps(_objectSpread({}, props), {
        title: t("채티 만족도 조사"),
        hideCloseButton: true,
        children: [
            view === "rating" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                        css: ratingDescriptionCSS,
                        children: t("채티 사용에 만족하고 있으신가요?")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        css: ratingCSS,
                        children: _toConsumableArray(Array(5).keys()).map(function(i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                onClick: function() {
                                    return setValue("rating", i + 1);
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Image/* default */.Z, {
                                    src: values.rating > i ? star_active : star_inactive,
                                    width: 40,
                                    height: 38,
                                    alt: t("별점")
                                })
                            }, "app-review-rating-".concat(i));
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalButton */.mH, {
                        text: t("평가하기"),
                        onClick: handleRating
                    })
                ]
            }),
            view === "feedback" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                        className: "multiline",
                        children: t("소중한 의견 참고하여\n더 좋은 채티를 만들어가겠습니다!")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_form/* Textarea */.gx, {
                        css: (0,css/* marginXTop */.cT)(dist_esm/* Spacing.medium */.Ki.medium),
                        placeholder: t("소중한 의견을 적어주세요"),
                        minRows: 4,
                        maxRows: 4,
                        maxLength: 300,
                        name: "reason",
                        value: values.reason,
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalButton */.mH, {
                        text: t("전송하기"),
                        disabled: !isValidated || isSubmitting,
                        onClick: submit
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalButton */.mH, {
                        type: "text",
                        text: t("다음에 할게요"),
                        onClick: function() {
                            review("far_later");
                        }
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var modal_AppReviewModal = (AppReviewModal);

// EXTERNAL MODULE: ./components/common/DottedList.tsx
var DottedList = __webpack_require__(10379);
;// CONCATENATED MODULE: ./components/modal/HonorApplicantModal.tsx
function HonorApplicantModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HonorApplicantModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HonorApplicantModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function HonorApplicantModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function HonorApplicantModal_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        HonorApplicantModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function HonorApplicantModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HonorApplicantModal_templateObject() {
    var data = HonorApplicantModal_taggedTemplateLiteral([
        "\n  padding-top: 14px;\n"
    ]);
    HonorApplicantModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HonorApplicantModal_templateObject1() {
    var data = HonorApplicantModal_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n\n    background-color: ",
        ";\n    padding: ",
        "px 0;\n    border-radius: ",
        "px;\n  "
    ]);
    HonorApplicantModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = HonorApplicantModal_taggedTemplateLiteral([
        "\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    margin-top: 12px;\n    margin-bottom: -12px;\n    color: ",
        ";\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var mainTextCSS = function(theme) {
    return (0,css/* textColor */.zP)(theme.colors.main500);
};
var headerTextCSS = function() {
    return (0,emotion_react_browser_esm.css)(HonorApplicantModal_templateObject());
};
var dotContainerCSS = function() {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(HonorApplicantModal_templateObject1(), theme.var.gray100, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Radius.medium */.wU.medium);
    };
};
var infoTextCSS = function() {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject2(), theme.var.gray500, dist_esm/* Typography.body12 */.ZT.body12);
    };
};
var HonorApplicantModal = function(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var items = [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
            className: "multiline",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(esm/* Trans */.cC, {
                t: t,
                i18nKey: "명예작품 기다리면 무료 모달 설명1",
                children: [
                    "매월 1일 신규 ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                        css: mainTextCSS,
                        children: "명예작품"
                    }),
                    "이 선정됩니다."
                ]
            })
        }),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
            className: "multiline",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(esm/* Trans */.cC, {
                t: t,
                i18nKey: "명예작품 기다리면 무료 모달 설명2",
                children: [
                    "명예작품으로 선정되는 모든 작품은",
                    "\n",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                        css: mainTextCSS,
                        children: "기다리면 무료"
                    }),
                    "로 전환됩니다."
                ]
            })
        }),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
            className: "multiline",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(esm/* Trans */.cC, {
                t: t,
                i18nKey: "명예작품 기다리면 무료 모달 설명3",
                children: "기존 예약 회차는 모두 ‘전부 공개’로 전환됩니다."
            })
        }),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
            className: "multiline",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(esm/* Trans */.cC, {
                t: t,
                i18nKey: "명예작품 기다리면 무료 모달 설명4",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                        css: mainTextCSS,
                        children: "기다리면 무료"
                    }),
                    "가 적용된 작품의 첫 3회차는 무료,",
                    "\n",
                    "최신화 3회차는 유료로 제공됩니다."
                ]
            })
        }), 
    ];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* default */.ZP, HonorApplicantModal_objectSpreadProps(HonorApplicantModal_objectSpread({}, props), {
        title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
            className: "multiline",
            css: headerTextCSS,
            children: t("명예작품\n[기다리면 무료] 전환 안내")
        }),
        hideHeaderBorder: true,
        hideCloseButton: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(DottedList/* default */.Z, {
                items: items,
                css: dotContainerCSS
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: infoTextCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                        icon: icon/* InfoCircle */.Zd,
                        size: dist_esm/* Sizes.medium */.u8.medium,
                        color: theme.var.gray500
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "multiline",
                        children: t("명예작품의 ‘기다리면 무료’ 전환은 작가의 결정이 아닌\n채티의 내부 정책임을 안내드립니다.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalButton */.mH, {
                text: t("확인")
            })
        ]
    }));
};
/* harmony default export */ var modal_HonorApplicantModal = (HonorApplicantModal);

// EXTERNAL MODULE: ./components/modal/NotificationModal.tsx
var NotificationModal = __webpack_require__(30738);
// EXTERNAL MODULE: ./components/modal/ShareModal.tsx + 3 modules
var ShareModal = __webpack_require__(30285);
// EXTERNAL MODULE: ./components/modal/StoryBadgeInfoModal.tsx
var StoryBadgeInfoModal = __webpack_require__(50758);
// EXTERNAL MODULE: ./utils/date.ts + 31 modules
var date = __webpack_require__(9987);
;// CONCATENATED MODULE: ./components/modal/WaitfreeInfoModal.tsx
function WaitfreeInfoModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function WaitfreeInfoModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            WaitfreeInfoModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function WaitfreeInfoModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function WaitfreeInfoModal_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        WaitfreeInfoModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var WaitfreeInfoModal_mainTextCSS = function(theme) {
    return (0,css/* textColor */.zP)(theme.colors.main500);
};
var WaitfreeInfoModal = function(_param) {
    var waitfreeBlockCount = _param.waitfreeBlockCount, waitfreeDurationInSeconds = _param.waitfreeDuration, props = _objectWithoutProperties(_param, [
        "waitfreeBlockCount",
        "waitfreeDuration"
    ]);
    var t = (0,esm/* useTranslation */.$G)().t;
    var waitfreeDuration = (0,date/* formatDuration */.LU)(waitfreeDurationInSeconds);
    var items = [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
            className: "multiline",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(esm/* Trans */.cC, {
                t: t,
                i18nKey: "기다리면 무료 모달 설명1",
                children: [
                    "‘기다리면 무료’로 회차를 보고",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                        css: WaitfreeInfoModal_mainTextCSS,
                        children: {
                            waitfreeDuration: waitfreeDuration
                        }
                    }),
                    "을 기다리면 1화씩",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                        css: WaitfreeInfoModal_mainTextCSS,
                        children: "무료"
                    }),
                    "로 공개됩니다."
                ]
            })
        }),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
            className: "multiline",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(esm/* Trans */.cC, {
                t: t,
                i18nKey: "기다리면 무료 모달 설명2",
                children: [
                    "‘기다리면 무료’는 1화를 ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                        css: WaitfreeInfoModal_mainTextCSS,
                        children: "3일"
                    }),
                    "동안 볼 수 있습니다."
                ]
            })
        }),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
            className: "multiline",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(esm/* Trans */.cC, {
                t: t,
                i18nKey: "기다리면 무료 모달 설명3",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                        css: WaitfreeInfoModal_mainTextCSS,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                            children: [
                                "최신 ",
                                {
                                    waitfreeBlockCount: waitfreeBlockCount
                                },
                                "화"
                            ]
                        })
                    }),
                    "는 ‘기다리면 무료’ 대상이 아닙니다."
                ]
            })
        }), 
    ];
    var filteredItems = waitfreeBlockCount === 0 ? items.slice(0, -1) : items;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* default */.ZP, WaitfreeInfoModal_objectSpreadProps(WaitfreeInfoModal_objectSpread({}, props), {
        title: t("{{waitfreeDuration}}마다 1회차 무료", {
            waitfreeDuration: waitfreeDuration
        }),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(DottedList/* default */.Z, {
                items: filteredItems
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalButton */.mH, {
                text: t("확인")
            })
        ]
    }));
};
/* harmony default export */ var modal_WaitfreeInfoModal = (WaitfreeInfoModal);

// EXTERNAL MODULE: ./components/skeleton/StoryDetailSkeleton.tsx
var StoryDetailSkeleton = __webpack_require__(78113);
// EXTERNAL MODULE: ./components/stories/DonationButton.tsx
var DonationButton = __webpack_require__(15872);
// EXTERNAL MODULE: ./hooks/useBundlePass.ts
var useBundlePass = __webpack_require__(30462);
// EXTERNAL MODULE: ./stores/useAutoPurchaseStore.ts
var useAutoPurchaseStore = __webpack_require__(72315);
// EXTERNAL MODULE: ./stores/useLoadingStore.ts
var useLoadingStore = __webpack_require__(70182);
// EXTERNAL MODULE: ./components/common/HorizontalFilter.tsx
var HorizontalFilter = __webpack_require__(61507);
// EXTERNAL MODULE: ./components/common/NativeInFeedAd.tsx
var NativeInFeedAd = __webpack_require__(80521);
// EXTERNAL MODULE: ./components/common/Pagination.tsx
var Pagination = __webpack_require__(39753);
// EXTERNAL MODULE: ./components/skeleton/Frame.tsx
var Frame = __webpack_require__(19827);
;// CONCATENATED MODULE: ./components/skeleton/EpisodeSkeleton.tsx
function EpisodeSkeleton_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EpisodeSkeleton_templateObject() {
    var data = EpisodeSkeleton_taggedTemplateLiteral([
        "\n  padding: ",
        "px ",
        "px;\n  display: grid;\n  box-sizing: content-box;\n  height: 42px;\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  gap: ",
        "px;\n\n  div:nth-of-type(1) {\n    grid-column: 1 / 4;\n    grid-row: 1;\n  }\n\n  div:nth-of-type(2) {\n    grid-column: 1 / 2;\n    grid-row: 2;\n  }\n\n  div:nth-of-type(3) {\n    grid-column: 4;\n    grid-row: 2;\n  }\n"
    ]);
    EpisodeSkeleton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var skeletonCSS = (0,emotion_react_browser_esm.css)(EpisodeSkeleton_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.medium */.Ki.medium);
var EpisodeSkeleton = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: skeletonCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Frame/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Frame/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Frame/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var skeleton_EpisodeSkeleton = (EpisodeSkeleton);

// EXTERNAL MODULE: ./components/skeleton/SkeletonList.tsx
var SkeletonList = __webpack_require__(6668);
// EXTERNAL MODULE: ./components/stories/Episode.tsx
var Episode = __webpack_require__(6084);
// EXTERNAL MODULE: ./api/episode.ts
var episode = __webpack_require__(58371);
// EXTERNAL MODULE: ./database/database.config.ts
var database_config = __webpack_require__(78689);
// EXTERNAL MODULE: ./utils/hook.ts
var hook = __webpack_require__(97033);
// EXTERNAL MODULE: ./utils/query.ts
var utils_query = __webpack_require__(96261);
;// CONCATENATED MODULE: ./components/stories/EpisodeList.tsx
function EpisodeList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function EpisodeList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function EpisodeList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EpisodeList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function EpisodeList_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function EpisodeList_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        EpisodeList_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || EpisodeList_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function EpisodeList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EpisodeList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return EpisodeList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EpisodeList_arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function EpisodeList_templateObject() {
    var data = EpisodeList_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ",
        "px ",
        "px;\n  background-color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  z-index: 3;\n  ",
        ";\n\n  p {\n    font-size: ",
        "px;\n  }\n"
    ]);
    EpisodeList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












// import { useLiveQuery } from 'dexie-react-hooks';


















var PreviewDonationModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1953), __webpack_require__.e(2403), __webpack_require__.e(4099), __webpack_require__.e(742)]).then(__webpack_require__.bind(__webpack_require__, 84099)).then(function(mod) {
        return mod.PreviewDonationModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84099)
            ];
        }
    },
    ssr: false
});
var EpisodePurchaseModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1953), __webpack_require__.e(5509)]).then(__webpack_require__.bind(__webpack_require__, 65509));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65509)
            ];
        }
    },
    ssr: false
});
var HIDDEN_STATS_STORY_IDS = [
    9817116,
    9817120,
    9817119,
    9817121
];
var ADULT_STORY_IDS = (0,misc/* isEnv */.h5)("production") ? [
    7091606,
    7091607,
    7091611,
    7091612,
    7091613,
    7091614,
    7091615,
    7091616,
    7091617,
    7091618,
    7091619,
    7091620,
    7091621,
    7091622,
    7091623,
    7091624,
    7091625,
    7091626,
    7091627,
    7091628,
    7091629,
    7091630,
    7091631,
    7091632,
    7091633,
    7091634,
    7091636,
    7091637,
    7091638,
    7091639,
    7091640,
    7091641,
    7091642,
    7091643,
    7091644,
    7091646,
    7091647,
    7091648,
    7091649,
    7091650,
    7091651,
    7091652,
    7091653,
    7091654,
    7091655,
    7091656,
    7091657,
    7091658,
    7091659,
    7091660,
    7091661,
    7091662,
    7091663,
    7091664,
    7091665,
    7091666,
    7091667,
    7091668,
    7091669,
    7091670,
    7091671,
    7091672,
    7091673,
    7091675,
    7091676,
    7091677,
    7091678,
    7091679,
    7091680,
    7091681,
    7091682,
    7091683,
    7091684,
    7091685,
    7091686,
    7091687,
    7091688,
    7091689,
    7091690,
    7091691,
    7091692,
    7091693,
    7091694,
    7091695,
    7091696,
    7091698,
    7091699,
    7091700,
    7091701,
    7091703,
    7091704,
    7091705,
    7091706,
    7091707,
    7091708,
    7091709,
    7091710,
    7091711,
    7091712,
    7091713,
    7091714,
    7091715,
    7091716,
    7091717,
    7091718,
    7091719,
    7091720,
    7091721,
    7091722,
    7091723,
    7091724,
    7091725,
    7091727,
    7091728,
    7091729,
    7091730,
    7091731,
    7091732,
    7091733,
    7091736,
    7091737,
    7091738,
    7091739,
    7091740,
    7091742,
    7091743,
    7091744,
    7091747,
    7091748,
    7091750,
    7091886, 
] : [];
var episodeListHeaderCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(EpisodeList_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, theme.var.white, theme.border.lightest, (0,css/* sticky */.CA)(44), dist_esm/* FontSizes.small */.TS.small);
};
var EpisodeList = function(param) {
    var story = param.story;
    var t = (0,esm/* useTranslation */.$G)().t;
    var web = (0,webview/* useWebView */.B9)().web;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var router = (0,next_router.useRouter)();
    var history = (0,hook/* useHistory */.k6)();
    var storyId = (0,utils_query/* getRouterQuery */.Fm)(router.query.storyId);
    var isExpiredStory = (story === null || story === void 0 ? void 0 : story.licenseStatus) === "inactive";
    var platform = (0,global/* useGlobalContext */.bN)().platform;
    var vendor = platform === constants/* Platform.ios */.t4.ios ? constants/* PAYMENT_VENDOR.apple */.CO.apple : constants/* PAYMENT_VENDOR.standard */.CO.standard;
    var ref = (0,useBundlePass/* useBundlePass */.p)({
        vendor: vendor
    }), isPurchaseDailyFreePass = ref.isPurchaseDailyFreePass, isShowDailyFreePassBanner = ref.isShowDailyFreePassBanner;
    var isShowDailyFreePass = isShowDailyFreePassBanner && !isPurchaseDailyFreePass;
    var isPurchaseLoadingRef = (0,react.useRef)(false);
    // const readHistories = useLiveQuery(
    //   () =>
    //     db.readHistory
    //       .where('storyId')
    //       .equals(storyId)
    //       .toArray((items) => items.map((item) => item.episodeId)),
    //   [storyId],
    //   [] as number[]
    // );
    var setLoading = (0,useLoadingStore/* useLoadingStore */.R)().setLoading;
    var autoPurchase = (0,useAutoPurchaseStore/* useAutoPurchaseStore */.O)().autoPurchase;
    var ref1 = (0,hook/* useMe */.Pi)(), me = ref1.data;
    var ref2 = (0,react.useState)([
        0
    ]), readHistories = ref2[0], setReadHistories = ref2[1];
    var ref3 = (0,react.useState)((0,utils_query/* getRouterQuery */.Fm)(router.query.ordering) || (story.isFinished ? "oldest" : "newest")), ordering = ref3[0], setOrdering = ref3[1];
    var queryKey = constants/* QUERY_KEYS.STORY.EPISODE_LIST */.U7.STORY.EPISODE_LIST(storyId, ordering);
    var query = (0,utils_query/* usePaginationQuery */.Zl)(queryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,episode/* fetchEpisodes */.lN)(storyId, ordering, pageParam);
    }, {
        suspense: false
    });
    var queryClient = (0,es.useQueryClient)();
    var ref4 = (0,es.useMutation)(episode/* purchaseEpisodeByBalloon */.Qv), purchaseEpisode = ref4.mutate;
    var ref5 = (0,es.useMutation)(episode/* previewEpisodeByBalloon */.VD), previewEpisode = ref5.mutate;
    var optimistic = (0,utils_query/* useOptimisticUpdate */.p7)();
    /** Modal */ var ref6 = _slicedToArray((0,useModal/* useModal */.d)("episode-purchase-modal", {
        routeChange: false
    }), 3), isEpisodePurchaseModalOpen = ref6[0], ref7 = ref6[1], openEpisodePurchaseModal = ref7.open, closeEpisodePurchaseModal = ref7.close, episodeForPurchase = ref6[2];
    var ref8 = _slicedToArray((0,useModal/* useModal */.d)("preview-donation-modal", {
        routeChange: false
    }), 3), isPreviewDonationModalOpen = ref8[0], ref9 = ref8[1], openPreviewDonationModal = ref9.open, closePreviewDonationModal = ref9.close, episodeForPreview = ref8[2];
    var goToEpisode = (0,react.useCallback)(function(episode) {
        var url = "/stories/".concat(story.id, "/episodes/").concat(episode.id);
        if (story.latestRead && episode.id === story.latestRead.episodeId) {
            router.push("".concat(url).concat((0,misc/* toQueryString */.UK)({
                readFrom: constants/* EpisodeReadFrom.list */.VG.list
            })));
        } else {
            router.push(url);
        }
    }, [
        story
    ]);
    var handleEpisodeClick = (0,react.useCallback)(function(episode) {
        if (isExpiredStory && episode.purchaseType !== constants/* EpisodePurchaseType.possession */.Yc.possession) {
            alert("소장한 회차만 볼 수 있습니다.");
            return;
        }
        if (episode.isFree) {
            goToEpisode(episode);
            return;
        }
        if (!me) {
            if (platform === constants/* Platform.web */.t4.web) {
                router.replace("/signin");
                return;
            }
            alert(t("로그인 후 사용이 가능합니다."));
            return;
        }
        // 예약 공개 작품
        if (episode.status === constants/* EpisodeStatus.bookedPublic */._$.bookedPublic) {
            if (isPurchaseDailyFreePass && !episode.purchaseType) {
                handlePreviewEpisodeByStoryPass(episode);
                return;
            }
            // 먼저보기 구매하지 않은 경우
            if (episode.purchaseType !== constants/* EpisodePurchaseType.preview */.Yc.preview) {
                if (isShowDailyFreePass) {
                    firebase.logEvent("show_daily_pass_banner", {
                        type: "preview_banner"
                    });
                }
                openPreviewDonationModal(episode);
                return;
            }
        }
        // 대여 만료 또는 구매하지 않은 경우
        if (!episode.purchaseType || // 구매하지 않았을경우
        episode.purchaseType === constants/* EpisodePurchaseType.rental */.Yc.rental && //기다무 대여일경우
        episode.purchaseExpired && (0,date/* isBefore */.RR)(episode.purchaseExpired, new Date()) // 기다무 대여기간 만료일경우
        ) {
            // 기다리면 무료 구매 가능 여부 확인
            if ((0,misc/* checkWaitfreeStory */.bY)(story)) {
                // 기다무 구매 가능할경우
                if (!episode.isWaitfreeBlocked && (!story.waitfreeReset || (0,date/* isAfter */.Ax)(new Date(), story.waitfreeReset))) {
                    handlePurchaseEpisode(episode, constants/* EpisodePurchaseType.waitfree */.Yc.waitfree, false, false);
                    return;
                }
            }
            // 자동 구매
            if (autoPurchase && autoPurchase.storyId === story.id) {
                handlePurchaseEpisode(episode, autoPurchase.purchaseType, autoPurchase.isAutoApplyVoucher, false);
                return;
            }
            if (isShowDailyFreePass) {
                firebase.logEvent("show_daily_pass_banner", {
                    type: "waitfree_banner"
                });
            }
            openEpisodePurchaseModal(episode);
            return;
        }
        if (isPurchaseDailyFreePass) {
            web.showToast("하루프리패스권으로 회차를 열람했어요!");
        }
        goToEpisode(episode);
    }, [
        me,
        story,
        autoPurchase,
        isPurchaseDailyFreePass
    ]);
    var handleEpisodeCommentClick = (0,react.useCallback)(function(episode) {
        router.push("/comments".concat((0,misc/* toQueryString */.UK)({
            objectType: constants/* CommentObjectType.episode */.oe.episode,
            objectId: episode.id,
            storyId: story.id
        })));
    }, []);
    var handlePurchaseEpisode = (0,react.useCallback)(function(episode, purchaseType, isAutoApplyVoucher) {
        var checkModal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
        if (isPurchaseLoadingRef.current) {
            return;
        }
        isPurchaseLoadingRef.current = true;
        setLoading(true);
        purchaseEpisode({
            storyId: story.id,
            episodeId: episode.id,
            isAutoApplyVoucher: isAutoApplyVoucher,
            type: purchaseType
        }, {
            onSuccess: function(data) {
                if (purchaseType === constants/* EpisodePurchaseType.waitfree */.Yc.waitfree) {
                    web.showToast(t("기다리면 무료로 회차를 열람하였습니다."));
                    var storyQueryKey = constants/* QUERY_KEYS.STORY.ONE */.U7.STORY.ONE(storyId);
                    optimistic.update(storyQueryKey, function(story) {
                        var ref;
                        return EpisodeList_objectSpreadProps(EpisodeList_objectSpread({}, story), {
                            waitfreeReset: (ref = data === null || data === void 0 ? void 0 : data.story) === null || ref === void 0 ? void 0 : ref.waitfreeReset
                        });
                    });
                } else if (purchaseType === constants/* EpisodePurchaseType.rental */.Yc.rental) {
                    web.showToast(t("회차를 대여하였습니다."));
                } else if (purchaseType === constants/* EpisodePurchaseType.possession */.Yc.possession) {
                    web.showToast(t("회차를 소장하였습니다."));
                } else if (purchaseType === constants/* EpisodePurchaseType.storyPass */.Yc.storyPass) {
                    web.showToast(t("하루프리패스권으로 회차를 열람했어요!"));
                    [
                        "newest",
                        "oldest"
                    ].forEach(function(ordering) {
                        optimistic.update(constants/* QUERY_KEYS.STORY.EPISODE_LIST */.U7.STORY.EPISODE_LIST(storyId, ordering), {
                            purchaseType: data.episode.purchaseType,
                            purchaseExpired: data.episode.purchaseExpired
                        }, {
                            id: episode.id
                        });
                    });
                }
                optimistic.update(queryKey, data.episode, {
                    id: episode.id
                });
                queryClient.invalidateQueries([
                    "voucherRecommendation"
                ]);
                if (checkModal) {
                    closeEpisodePurchaseModal({
                        afterClose: function() {
                            router.push("/stories/".concat(storyId, "/episodes/").concat(episode.id));
                        }
                    });
                } else {
                    router.push("/stories/".concat(storyId, "/episodes/").concat(episode.id));
                }
            },
            onSettled: function() {
                isPurchaseLoadingRef.current = false;
                setLoading(false);
            }
        });
    }, [
        story
    ]);
    var userQueryKey = constants/* QUERY_KEYS.USER.ONE */.U7.USER.ONE(story.user.id);
    var handlePreviewEpisodeByStoryPass = function(episode) {
        previewEpisode({
            storyId: story.id,
            episodeId: episode.id,
            balloon: 200,
            message: t("먼저 보고가요!"),
            useStoryPass: true
        }, {
            onSuccess: function() {
                web.showToast("하루프리패스권으로 회차를 열람했어요!");
                optimistic.update(userQueryKey, function(user) {
                    return EpisodeList_objectSpreadProps(EpisodeList_objectSpread({}, user), {
                        isFan: true
                    });
                });
                optimistic.update(queryKey, {
                    purchaseType: constants/* EpisodePurchaseType.preview */.Yc.preview
                }, {
                    id: episode.id
                });
                goToEpisode(episode);
            // firebase.logEvent('preview_content', {
            //   contentType: 'episode',
            //   storyId: story.id,
            //   episodeId: episode.id,
            //   balloon: values.balloon,
            // });
            }
        });
    };
    var handlePreviewEpisode = (0,react.useCallback)(function(episode) {
        closePreviewDonationModal({
            afterClose: function() {
                router.push("/stories/".concat(storyId, "/episodes/").concat(episode.id));
            }
        });
        optimistic.update(queryKey, {
            purchaseType: constants/* EpisodePurchaseType.preview */.Yc.preview
        }, {
            id: episode.id
        });
    }, []);
    var handleChangeOrder = (0,react.useCallback)(function(ordering) {
        setOrdering(ordering);
        history.replaceShallow("/stories/[storyId]".concat((0,misc/* toQueryString */.UK)({
            storyId: storyId,
            ordering: ordering
        })), "/stories/".concat(storyId).concat((0,misc/* toQueryString */.UK)({
            ordering: ordering
        })));
    }, []);
    (0,react.useEffect)(function() {
        if (!("indexedDB" in window) || !database_config.db || !window.indexedDB) {
            return;
        }
        if ( true && storyId && (window === null || window === void 0 ? void 0 : window.indexedDB)) {
            var getReadHistories = function() {
                var _ref = _asyncToGenerator(function() {
                    var result, err;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    database_config.db === null || database_config.db === void 0 ? void 0 : database_config.db.readHistory.where("storyId").equals(storyId).toArray(function(items) {
                                        return items.map(function(item) {
                                            return item.episodeId;
                                        });
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                setReadHistories(result);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                setReadHistories([]);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function getReadHistories() {
                    return _ref.apply(this, arguments);
                };
            }();
            getReadHistories();
        }
    }, [
        storyId
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("header", {
                css: episodeListHeaderCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        children: t("회차({{number}})", {
                            number: query.totalCount
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HorizontalFilter/* default */.Z, {
                        options: [
                            {
                                label: t("최신순"),
                                value: "newest"
                            },
                            {
                                label: t("첫회차순"),
                                value: "oldest"
                            }, 
                        ],
                        selected: ordering,
                        onChange: handleChangeOrder
                    })
                ]
            }),
            query.isLoading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SkeletonList/* default */.Z, {
                skeleton: skeleton_EpisodeSkeleton
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                name: "story-episode-list",
                query: query,
                border: true,
                inFeedAd: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NativeInFeedAd/* default */.Z, {
                    unitKey: "episode_mobile"
                }),
                children: function(item) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                        backgroundColor: item.status === constants/* EpisodeStatus.review */._$.review || item.status === constants/* EpisodeStatus.reject */._$.reject ? theme.var.gray100 : readHistories.indexOf(item.id) > -1 ? theme.var.highlight : undefined,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Episode/* default */.Z, EpisodeList_objectSpreadProps(EpisodeList_objectSpread({}, item), {
                            isExpired: isExpiredStory,
                            renderPrice: function() {
                                if (story.hasBookedPublic && !isExpiredStory) {
                                    if (item.purchaseType === constants/* EpisodePurchaseType.preview */.Yc.preview) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("small", {
                                            children: t("먼저봄")
                                        });
                                    }
                                    return null;
                                }
                                // 유료 회차가 있는 경우, 무료 표시
                                if (story.freeEpisodeCount < story.episodeCount) {
                                    if (item.purchaseType === constants/* EpisodePurchaseType.rental */.Yc.rental && item.purchaseExpired && !isExpiredStory) {
                                        var now = new Date();
                                        if ((0,date/* isBefore */.RR)(item.purchaseExpired, now)) {
                                            return null;
                                        }
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("small", {
                                            children: t("{{purchaseExpired}} 남음", {
                                                purchaseExpired: (0,date/* formatDistance */.Bb)(item.purchaseExpired, now, {
                                                    addSuffix: false
                                                })
                                            })
                                        });
                                    }
                                    if (item.purchaseType === constants/* EpisodePurchaseType.possession */.Yc.possession) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("small", {
                                            children: t("소장")
                                        });
                                    }
                                    if (item.isFree && !isExpiredStory) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("small", {
                                            children: t("무료")
                                        });
                                    }
                                }
                                return null;
                            },
                            commentEnabled: story.isCommentEnabled && !isExpiredStory,
                            hideStats: HIDDEN_STATS_STORY_IDS.includes(story.id),
                            hideDate: isExpiredStory || ADULT_STORY_IDS.indexOf(story.id) > -1,
                            onClick: handleEpisodeClick,
                            onCommentClick: handleEpisodeCommentClick
                        }))
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EpisodePurchaseModal, {
                name: "episode-purchase-modal",
                open: isEpisodePurchaseModalOpen,
                story: story,
                episode: episodeForPurchase,
                possessionOnly: story.theme === constants/* StoryTheme.tapNovel */.xb.tapNovel,
                onClose: closeEpisodePurchaseModal,
                onPurchase: handlePurchaseEpisode
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PreviewDonationModal, {
                name: "preview-donation-modal",
                open: isPreviewDonationModalOpen,
                story: story,
                episode: episodeForPreview,
                onClose: closePreviewDonationModal,
                onPreview: handlePreviewEpisode
            })
        ]
    });
};
/* harmony default export */ var stories_EpisodeList = (EpisodeList);

;// CONCATENATED MODULE: ./components/stories/SimpleStampRanking.tsx
function SimpleStampRanking_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SimpleStampRanking_templateObject() {
    var data = SimpleStampRanking_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  ",
        ";\n  line-height: 100%;\n  text-align: center;\n\n  .highlight {\n    background-image: linear-gradient(160deg, #17dce4 0%, #4db4ee 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n\n  .title {\n    .crown {\n      text-align: center;\n      height: 17px;\n    }\n  }\n\n  .time {\n    font-size: 8px;\n    font-weight: 400;\n    color: ",
        ";\n  }\n"
    ]);
    SimpleStampRanking_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var titleCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(SimpleStampRanking_templateObject(), dist_esm/* Typography.h6 */.ZT.h6, theme.var.gray400);
};
var SimpleStampRanking = function(param) {
    var weeklySummary = param.weeklySummary;
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var today = new Date();
    var isPublishInCurrentWeek = weeklySummary && (0,date/* isAfter */.Ax)(today, new Date(weeklySummary.startDateKst)) && !(0,date/* isAfter */.Ax)((0,date/* getOnlyDate */.ce)(today), (0,date/* getOnlyDate */.ce)(new Date(weeklySummary.endDateKst)));
    var isInRanking = isPublishInCurrentWeek && weeklySummary.stampRanking && weeklySummary.stampRanking.rank < 1000;
    if (!isPublishInCurrentWeek) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
        backgroundColor: theme.border.space,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
            css: titleCSS,
            children: (weeklySummary === null || weeklySummary === void 0 ? void 0 : weeklySummary.stampRanking) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                        className: "title",
                        children: [
                            t("1일 1연재 스탬프"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "highlight",
                                children: t(isInRanking ? " 랭킹 ".concat((ref = weeklySummary.stampRanking) === null || ref === void 0 ? void 0 : ref.rank, "등") : " 순위권 진입 준비중")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "crown",
                                children: t(!isInRanking ? "이에요!" : " \uD83D\uDC51")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                        className: "time",
                        children: t(" ".concat((0,date/* formatDate */.p6)(new Date(weeklySummary.stampRanking.lastUpdatedAt), "yyyy.MM.dd HH:mm"), " 기준"))
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var stories_SimpleStampRanking = (SimpleStampRanking);

// EXTERNAL MODULE: ./components/user/User.tsx
var User = __webpack_require__(40477);
// EXTERNAL MODULE: ./api/chatbot.ts
var chatbot = __webpack_require__(23082);
// EXTERNAL MODULE: ./api/story.ts
var api_story = __webpack_require__(10741);
// EXTERNAL MODULE: ./contexts/auth.tsx
var auth = __webpack_require__(71727);
;// CONCATENATED MODULE: ./pages/stories/[storyId]/index.tsx
function _storyId_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _storyId_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _storyId_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _storyId_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _storyId_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _storyId_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _storyId_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _storyId_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _storyId_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        _storyId_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _storyId_slicedToArray(arr, i) {
    return _storyId_arrayWithHoles(arr) || _storyId_iterableToArrayLimit(arr, i) || _storyId_unsupportedIterableToArray(arr, i) || _storyId_nonIterableRest();
}
function _storyId_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _storyId_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _storyId_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _storyId_arrayLikeToArray(o, minLen);
}
function _storyId_templateObject() {
    var data = _storyId_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-bottom: 62.5%;\n  ",
        "\n\n  ",
        " {\n    padding-bottom: 0;\n    height: 280px;\n    max-width: 500px;\n    margin: 0 auto;\n    border-radius: 0 0 12px 12px;\n    overflow: hidden;\n  }\n  ",
        " {\n    height: 320px;\n    max-width: 560px;\n    border-radius: 0 0 16px 16px;\n  }\n\n  > div {\n    position: absolute;\n    width: 100%;\n    padding: ",
        "px;\n    bottom: 0;\n    color: ",
        ";\n    ",
        "\n\n    ",
        " {\n      padding: ",
        "px;\n    }\n    ",
        " {\n      padding: ",
        "px;\n    }\n\n    h3 {\n      margin-top: ",
        "px;\n      margin-bottom: ",
        "px;\n    }\n\n    div {\n      button + button {\n        margin-left: ",
        "px;\n      }\n    }\n  }\n"
    ]);
    _storyId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _storyId_templateObject1() {
    var data = _storyId_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  > * + * {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _storyId_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _storyId_templateObject2() {
    var data = _storyId_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-right: ",
        "px;\n  font-size: ",
        "px;\n  color: ",
        ";\n\n  button {\n    position: absolute;\n    bottom: ",
        "px;\n    right: 0;\n  }\n"
    ]);
    _storyId_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _storyId_taggedTemplateLiteral([
        "\n  padding: ",
        "px ",
        "px;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: ",
        "px;\n  color: #721c24;\n  border-radius: ",
        "px;\n\n  ",
        " {\n    padding: ",
        "px ",
        "px;\n  }\n  ",
        " {\n    padding: ",
        "px ",
        "px;\n  }\n\n  p {\n    ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _storyId_taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _storyId_taggedTemplateLiteral([
        "\n  display: block;\n  font-size: ",
        "px;\n  margin-top: ",
        "px;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _storyId_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  p {\n    font-size: ",
        "px;\n\n    span + span {\n      margin-left: ",
        "px;\n      padding-left: ",
        "px;\n      border-left: 1px solid ",
        ";\n    }\n\n    button {\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _storyId_taggedTemplateLiteral([
        "\n  position: relative;\n  background-color: ",
        ";\n  color: ",
        ";\n  width: 80px;\n  height: 20px;\n  border-radius: ",
        "px;\n  overflow: hidden;\n  text-align: center;\n\n  > div {\n    position: absolute;\n    transition: width 0.2s;\n    width: 100%;\n    height: 100%;\n    background-color: ",
        ";\n  }\n\n  b {\n    position: relative;\n    z-index: 1;\n    font-size: ",
        "px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _storyId_taggedTemplateLiteral([
        "\n  padding: ",
        "px ",
        "px;\n  color: ",
        ";\n  background-color: ",
        ";\n\n  ",
        " {\n    padding: ",
        "px ",
        "px;\n  }\n  ",
        " {\n    padding: ",
        "px ",
        "px;\n  }\n\n  p {\n    text-align: center;\n    ",
        "\n\n    span {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _storyId_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: var(\n      --service-ultramarine_400,\n      linear-gradient(0deg, #5563e1 0%, #5563e1 100%),\n      linear-gradient(\n        0deg,\n        rgba(255, 255, 255, 0.2) 0%,\n        rgba(255, 255, 255, 0.2) 100%\n      ),\n      #2e41ef\n    );\n\n    padding: 10px 8px 10px 16px;\n    ",
        ";\n    color: ",
        ";\n    line-height: 15.6px;\n\n    h6 {\n      ",
        "\n      font-weight:700;\n    }\n\n    .enter-button {\n      display: flex;\n      margin-left: ",
        "px;\n      align-items: center;\n      gap: ",
        "px;\n      ",
        "\n      color:",
        "\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _storyId_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n    background: ",
        ";\n    padding: ",
        "px 0;\n    ",
        ";\n    color: ",
        ";\n    line-height: 12px;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _storyId_taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


























































var StoryDonationModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1953), __webpack_require__.e(2403), __webpack_require__.e(4099), __webpack_require__.e(742)]).then(__webpack_require__.bind(__webpack_require__, 84099)).then(function(mod) {
        return mod.StoryDonationModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84099)
            ];
        }
    },
    ssr: false
});
var coverImageCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_storyId_templateObject(), (0,css/* safeArea */.BI)("top"), css/* media.tablet */.BC.tablet, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.medium */.Ki.medium, theme.true.white, (0,css/* linearGradient */.bC)("bottom"), css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.medium */.Ki.medium);
};
var headerLabelCSS = (0,emotion_react_browser_esm.css)(_storyId_templateObject1(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
var summaryCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_storyId_templateObject2(), dist_esm/* Spacing.large */.Ki.large, dist_esm/* FontSizes.small */.TS.small, theme.var.gray600, dist_esm/* Spacing.xxxsmall */.Ki.xxxsmall);
};
var expiredCSS = (0,emotion_react_browser_esm.css)(_templateObject3(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Radius.small */.wU.small, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Typography.body14 */.ZT.body14);
var categoryCSS = (0,emotion_react_browser_esm.css)(_templateObject4(), dist_esm/* Spacing.small */.Ki.small);
var userFollowerCountCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject5(), dist_esm/* FontSizes.xsmall */.TS.xsmall, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, theme.var.gray500);
};
var waitfreeCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject6(), dist_esm/* FontSizes.small */.TS.small, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall, theme.var.gray200);
};
var waitfreeProgressCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject7(), theme.var.gray300, theme.true.white, dist_esm/* Radius.small */.wU.small, theme.colors.main500, dist_esm/* FontSizes.xsmall */.TS.xsmall);
};
var induceOfferwallCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject8(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, theme.var.black, theme.colors.main50, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Typography.body14 */.ZT.body14);
};
var honorApplicantCSS = function() {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject9(), dist_esm/* Typography.body12 */.ZT.body12, theme.var.white, dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Typography.body12 */.ZT.body12, theme.var.white);
    };
};
var honorBannerCSS = function() {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject10(), "linear-gradient(90deg, #04C8D0 0%, #1590D5 95.45%)", dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Typography.body12 */.ZT.body12, theme.var.white);
    };
};
var donationRankingTextCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject11(), dist_esm/* Typography.body12 */.ZT.body12, theme.colors.main500);
};
function isWaitfreeReady(story) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    return !!story.waitfreeReset && (0,date/* isAfter */.Ax)(story.waitfreeReset, now);
}
var StoryDetail = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,esm/* useTranslation */.$G)().t;
    var platform = (0,global/* useGlobalContext */.bN)().platform;
    var web = (0,webview/* useWebView */.B9)().web;
    var showToast = (0,useToast/* default */.Z)().showToast;
    var router = (0,next_router.useRouter)();
    var storyId = (0,utils_query/* getRouterQuery */.Fm)(router.query.storyId);
    var queryClient = (0,es.useQueryClient)();
    var optimistic = (0,utils_query/* useOptimisticUpdate */.p7)();
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var ref7 = (0,Badge/* useBadgePresets */.fw)(), mainFill = ref7.mainFill, honorFill = ref7.honorFill, redFill = ref7.redFill, purpleFill = ref7.purpleFill;
    var ref8 = (0,useStoryQuery/* useStoryQuery */.c)(), useFetchStory = ref8.useFetchStory, useWeeklySummary = ref8.useWeeklySummary;
    var ref9 = useFetchStory(storyId, {
        suspense: true
    }), story = ref9.data;
    var ref10 = useWeeklySummary(storyId), weeklySummaries = ref10.data;
    var adultGuard = (0,hook/* useAdultContentGuard */.rS)((story === null || story === void 0 ? void 0 : story.ageGrade) === constants/* StoryAgeGrade.adult */.ss.adult);
    var queryKey = constants/* QUERY_KEYS.STORY.ONE */.U7.STORY.ONE(storyId);
    var characterQueryKey = constants/* QUERY_KEYS.CHARACTER.STORY_CHARACTER */.U7.CHARACTER.STORY_CHARACTER(story === null || story === void 0 ? void 0 : story.id);
    var openOfferwall = (0,webview/* useOfferwall */.mK)().openOfferwall;
    (0,useBroadcastChannel/* useBroadcastChannel */.t)(useBroadcastChannel/* BROADCAST_CHANNEL.CHARACTER_UPDATE */._.CHARACTER_UPDATE, function() {
        queryClient.refetchQueries(characterQueryKey);
    });
    var isExpiredStory = (story === null || story === void 0 ? void 0 : story.licenseStatus) === "inactive";
    var isProduction = (0,misc/* isEnv */.h5)("production");
    var showSnow = story ? (story === null || story === void 0 ? void 0 : (ref = story.tags) === null || ref === void 0 ? void 0 : ref.findIndex(function(tag) {
        return tag.id === (isProduction ? 571093 : 419);
    })) >= 0 : false;
    var ref11 = (0,hook/* useNotification */.lm)(constants/* SettingType.story */.Sd.story, storyId, "newEpisodePushStatus"), userSetting = ref11.data;
    var ref12;
    var notificationOption = (ref12 = userSetting === null || userSetting === void 0 ? void 0 : userSetting.setting["newEpisodePushStatus"]) !== null && ref12 !== void 0 ? ref12 : "default";
    (0,hook/* useUserMarketItemInventories */.dV)([
        story === null || story === void 0 ? void 0 : story.user
    ]);
    var ref13 = (0,es.useMutation)(function(id) {
        return ((story === null || story === void 0 ? void 0 : story.isWatchLater) ? api_story/* deleteWatchLaterStory */.i : api_story/* postWatchLaterStory */.qN)(id);
    }), toggleLikeStory = ref13.mutate, isLikeStoryPending = ref13.isLoading;
    /**
   * states
   */ var ref14 = (0,react.useState)(new Date()), now = ref14[0], setNow = ref14[1];
    var ref15 = (0,react.useState)(false), isSummaryOpen = ref15[0], setSummaryOpen = ref15[1];
    var ref16;
    var ref17 = _storyId_slicedToArray((0,misc/* trimString */.gK)((ref16 = story === null || story === void 0 ? void 0 : story.summary) !== null && ref16 !== void 0 ? ref16 : ""), 2), summary1 = ref17[0], summary2 = ref17[1];
    var query = (0,es.useQuery)("honorPartners", common/* fetchHonorPartnershipPartners */.r8, {
        staleTime: Infinity,
        cacheTime: Infinity
    });
    var honorData = query.data;
    var characterQuery = (0,utils_query/* useChatPaginationQuery */.aI)(characterQueryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,chatbot/* fetchCharacters */.Em)({
            story_id: story === null || story === void 0 ? void 0 : story.id,
            order_by: "stat__message_count"
        }, pageParam);
    }, {
        enabled: !!(story === null || story === void 0 ? void 0 : story.id)
    });
    var filteredCharacter = (0,react.useMemo)(function() {
        var ref, ref1;
        var characters = (ref1 = characterQuery === null || characterQuery === void 0 ? void 0 : (ref = characterQuery.data) === null || ref === void 0 ? void 0 : ref.pages[0]) === null || ref1 === void 0 ? void 0 : ref1.items;
        var ref2;
        if (characters && ((ref2 = characters === null || characters === void 0 ? void 0 : characters.length) !== null && ref2 !== void 0 ? ref2 : 0) > 0) {
            return characters[0];
        }
        return undefined;
    }, [
        characterQuery === null || characterQuery === void 0 ? void 0 : (ref1 = characterQuery.data) === null || ref1 === void 0 ? void 0 : ref1.pages
    ]);
    /**
   * modal
   */ var ref18 = _storyId_slicedToArray((0,useModal/* useModal */.d)("story-share-modal"), 2), isShareModalOpen = ref18[0], ref19 = ref18[1], openShareModal = ref19.open, closeShareModal = ref19.close;
    var ref20 = _storyId_slicedToArray((0,useModal/* useModal */.d)("honor-partnership-story-info-modal"), 2), isHonorPartnershipStoryInfoModalOpen = ref20[0], ref21 = ref20[1], openHonorPartnershipStoryInfoModal = ref21.open, closeHonorPartnershipStoryInfoModal = ref21.close;
    var ref22 = _storyId_slicedToArray((0,useModal/* useModal */.d)("honor-partnership-applicant-info-modal"), 2), isHonorPartnershipApplicantInfoModalOpen = ref22[0], ref23 = ref22[1], openHonorPartnershipApplicantInfoModal = ref23.open, closeHonorPartnershipApplicantInfoModal = ref23.close;
    var ref24 = _storyId_slicedToArray((0,useModal/* useModal */.d)("original-story-info-modal"), 2), isOriginalStoryInfoModalOpen = ref24[0], ref25 = ref24[1], openOriginalStoryInfoModal = ref25.open, closeOriginalStoryInfoModal = ref25.close;
    var ref26 = _storyId_slicedToArray((0,useModal/* useModal */.d)("story-notification-modal"), 2), isNotificationModalOpen = ref26[0], ref27 = ref26[1], openNotificationModal = ref27.open, closeNotificationModal = ref27.close;
    var ref28 = _storyId_slicedToArray((0,useModal/* useModal */.d)("waitfree-info-modal"), 2), isWaitfreeInfoModalOpen = ref28[0], ref29 = ref28[1], openWaitfreeInfoModal = ref29.open, closeWaitfreeInfoModal = ref29.close;
    var ref30 = _storyId_slicedToArray((0,useModal/* useModal */.d)("donation-modal"), 2), isDonationModalOpen = ref30[0], ref31 = ref30[1], openDonationModal = ref31.open, closeDonationModal = ref31.close;
    var ref32 = _storyId_slicedToArray((0,useModal/* useModal */.d)("app-review-modal"), 2), isAppReviewModalOpen = ref32[0], ref33 = ref32[1], openAppReviewModal = ref33.open, closeAppReviewModal = ref33.close;
    var handleAction = (0,react.useCallback)(function(value) {
        switch(value){
            case "share":
                openShareModal();
                return;
            case "report":
                router.push("/report".concat((0,misc/* toQueryString */.UK)({
                    objectType: constants/* ReportObjectType.episode */.LB.episode,
                    storyId: storyId
                })));
                return;
            default:
                return;
        }
    }, [
        router
    ]);
    var handleGoToStoryCommentPage = (0,react.useCallback)(function() {
        router.push("/comments".concat((0,misc/* toQueryString */.UK)({
            objectType: constants/* CommentObjectType.story */.oe.story,
            objectId: storyId,
            storyId: storyId
        })));
    }, [
        storyId
    ]);
    var handleLikeStory = function() {
        toggleLikeStory(storyId, {
            onSuccess: function(data) {
                optimistic.update(queryKey, function(item) {
                    return _storyId_objectSpreadProps(_storyId_objectSpread({}, item), {
                        isWatchLater: !item.isWatchLater
                    });
                });
                if (data) {
                    var hideAppReviewUntil = localStorage/* ParsedStorage.getItem */.f.getItem("hideAppReviewUntil");
                    if (!hideAppReviewUntil || (0,date/* isAfter */.Ax)(new Date(), hideAppReviewUntil)) {
                        openAppReviewModal();
                    }
                    try {
                        if (platform === constants/* Platform.web */.t4.web) {
                            showToast({
                                text: "보관함 내 좋아요에 추가되었습니다.",
                                height: 100
                            });
                        }
                        web.showToast(t("보관함 내 좋아요에 추가되었습니다."));
                    } catch (err) {
                        return;
                    }
                } else {
                    try {
                        if (platform === constants/* Platform.web */.t4.web) {
                            showToast({
                                text: "보관함 내 좋아요에서 삭제되었습니다.",
                                height: 100
                            });
                        }
                        web.showToast(t("보관함 내 좋아요에서 삭제되었습니다."));
                    } catch (err1) {
                        return;
                    }
                }
            }
        });
    };
    var handleContinueReadEpisode = function() {
        if (!story) {
            return;
        }
        if (story.latestRead && story.latestRead.episodeTitle) {
            router.push("/stories/".concat(story.id, "/episodes/").concat(story.latestRead.episodeId).concat((0,misc/* toQueryString */.UK)({
                readFrom: constants/* EpisodeReadFrom.cta */.VG.cta
            })));
            return;
        }
        if (story.firstEpisode) {
            var ref;
            router.push("/stories/".concat(story.id, "/episodes/").concat((ref = story.firstEpisode) === null || ref === void 0 ? void 0 : ref.id));
        }
    };
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setNow(new Date());
        }, (0,minutesToMilliseconds/* default */.Z)(1));
        return function() {
            clearInterval(interval);
        };
    }, []);
    (0,react.useEffect)(function() {
        (0,misc/* setFlow */.kB)({
            name: "작품상세"
        });
    }, []);
    if (!story) {
        return null;
    }
    var isWaitfreeStory = (0,misc/* checkWaitfreeStory */.bY)(story);
    var notificationIconMapper = {
        enable: icon/* BellFill */.pk,
        disable: icon/* BellStroke */.ir,
        partial_enable: icon/* Bell */.Uo,
        default: icon/* Bell */.Uo
    };
    var isNotificationDisabled = notificationOption === "default" || notificationOption === "disable";
    var honorList = honorData === null || honorData === void 0 ? void 0 : honorData.map(function(honorUser) {
        return honorUser.partner.id.toString();
    });
    var ref34;
    var current = (ref34 = (ref2 = (0,misc/* getSettingDate */.jl)()) === null || ref2 === void 0 ? void 0 : ref2.date) !== null && ref34 !== void 0 ? ref34 : new Date();
    var eventStartDate = "".concat((0,date/* getYearAndMonth */.EM)(current), "-01T00:00:00");
    var eventEndDate = "".concat((0,date/* getYearAndMonth */.EM)(current), "-25T23:59:59");
    var isEventStart = (0,date/* isAfter */.Ax)(current, eventStartDate);
    var isEventEnd = (0,date/* isAfter */.Ax)(current, eventEndDate);
    var isHonorAuthor = story.user.hasHonorPartnership && (honorList === null || honorList === void 0 ? void 0 : honorList.includes(story.user.id.toString())) && isEventStart && !isEventEnd;
    var isHonorPartnershipApplicant = !isHonorAuthor && story.isHonorPartnershipApplicant;
    if (adultGuard.isBlocked) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(AdultContentBlocker/* default */.Z, {
            needsLogin: adultGuard.needsLogin,
            needsCertification: adultGuard.needsCertification,
            isLoading: adultGuard.isLoading,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {})
        });
    }
    var ref35, ref36;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("meta", {
                        property: "og:title",
                        content: story === null || story === void 0 ? void 0 : story.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("meta", {
                        property: "og:image",
                        content: story === null || story === void 0 ? void 0 : story.coverImage.attachment.url
                    }),
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("meta", {
                        property: "og:image:width",
                        content: (ref35 = (ref3 = story.coverImage.attachment.width) === null || ref3 === void 0 ? void 0 : ref3.toString()) !== null && ref35 !== void 0 ? ref35 : "1200"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("meta", {
                        property: "og:image:height",
                        content: (ref36 = (ref4 = story.coverImage.attachment.height) === null || ref4 === void 0 ? void 0 : ref4.toString()) !== null && ref36 !== void 0 ? ref36 : "600"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Seo/* default */.Z, {
                title: story.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Header/* default */.Z, {
                transparent: true,
                transparentFadeInAt: "100px",
                push: false,
                right: function(color) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                        children: !isExpiredStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                    className: "icon-btn",
                                    disabled: isLikeStoryPending,
                                    onClick: handleLikeStory,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                        icon: story.isWatchLater ? icon/* HeartFill */.Ic : icon/* Heart */.YK,
                                        color: story.isWatchLater ? theme.colors.yellow500 : color
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                    className: "icon-btn",
                                    onClick: openNotificationModal,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                        icon: notificationIconMapper[notificationOption],
                                        color: isNotificationDisabled ? color : theme.colors.yellow500
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ActionSheet/* default */.Z, {
                                    name: "my-story-action",
                                    options: [
                                        {
                                            label: t("공유하기"),
                                            value: "share"
                                        },
                                        {
                                            label: t("신고하기"),
                                            value: "report"
                                        }, 
                                    ],
                                    onSelect: handleAction,
                                    children: function(open) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                            className: "icon-btn",
                                            onClick: open,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                                icon: icon/* VerticalEllipsis */.oR,
                                                color: color
                                            })
                                        });
                                    }
                                })
                            ]
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: coverImageCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                        image: story.coverImage
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        children: [
                            " ",
                            showSnow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StorySnow/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                css: headerLabelCSS,
                                children: [
                                    story.ageGrade === constants/* StoryAgeGrade.adult */.ss.adult && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                        icon: icon/* AdultFill */.$L,
                                        color: theme.var.gray600
                                    }),
                                    story.hasHonorPartnership && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _storyId_objectSpreadProps(_storyId_objectSpread({
                                        text: t("명예작품")
                                    }, honorFill), {
                                        onClick: openHonorPartnershipStoryInfoModal
                                    })),
                                    story.type === constants/* StoryType.original */.nw.original && !isExpiredStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _storyId_objectSpreadProps(_storyId_objectSpread({
                                        text: t("오리지널")
                                    }, redFill), {
                                        onClick: openOriginalStoryInfoModal
                                    })),
                                    story.theme === constants/* StoryTheme.tapNovel */.xb.tapNovel && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _storyId_objectSpread({
                                        text: t("탭소설")
                                    }, purpleFill)),
                                    story.isFinished && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _storyId_objectSpread({
                                        text: t("완결")
                                    }, mainFill))
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h3", {
                                children: story.title
                            }),
                            ![
                                9817116,
                                9817120,
                                9817119,
                                9817121
                            ].includes(story.id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                        className: "text-btn icon-text",
                                        type: "button",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("span", {
                                            children: [
                                                (0,misc/* simplifyNumber */.Qh)({
                                                    value: story.tapCount
                                                }),
                                                " ",
                                                t("탭")
                                            ]
                                        })
                                    }),
                                    story.isCommentEnabled && !isExpiredStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("button", {
                                        className: "text-btn icon-text",
                                        type: "button",
                                        onClick: handleGoToStoryCommentPage,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("span", {
                                                children: [
                                                    (0,misc/* simplifyNumber */.Qh)({
                                                        value: story.commentCount
                                                    }),
                                                    " ",
                                                    t("댓글")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                                icon: icon/* ArrowRight */.ol,
                                                size: dist_esm/* Sizes.small */.u8.small,
                                                color: theme.true.white
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                    to: "/users/".concat(story.user.id),
                    left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(User/* default */.Z, _storyId_objectSpreadProps(_storyId_objectSpread({}, story.user), {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("small", {
                            css: userFollowerCountCSS,
                            children: t("{{followerCount, simplifyNumber}} 팔로워", {
                                followerCount: story.user.followerCount
                            })
                        })
                    }))
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Border/* default */.Z, {}),
            isHonorPartnershipApplicant && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: honorApplicantCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                                children: "명예작가 투고작을 보고 계시네요!"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                children: "명예작가에 선정되면, 기다리면 무료로 전환됩니다."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("button", {
                        className: "enter-button",
                        onClick: openHonorPartnershipApplicantInfoModal,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                children: t("자세히 보기")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                icon: icon/* ArrowRight */.ol,
                                size: dist_esm/* Sizes.small */.u8.small,
                                color: theme.var.white
                            })
                        ]
                    })
                ]
            }),
            isHonorAuthor && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: honorBannerCSS,
                children: "\uD83D\uDC51 명예 작가님의 작품입니다. 창작 활동을 응원해 주세요!"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Pad/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        css: summaryCSS,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                                className: "multiline",
                                children: [
                                    summary1,
                                    isSummaryOpen && summary2
                                ]
                            }),
                            summary2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                className: "icon-btn",
                                onClick: function() {
                                    return setSummaryOpen(function(prev) {
                                        return !prev;
                                    });
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                    icon: isSummaryOpen ? icon/* ArrowUp */.a2 : icon/* ArrowDown */.K5,
                                    size: dist_esm/* Sizes.small */.u8.small,
                                    color: theme.var.gray500
                                })
                            })
                        ]
                    }),
                    story.category && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                        css: categoryCSS,
                        children: (0,misc/* stringifyCategory */.HV)(story.category)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Tag/* TagList */.PS, {
                        tags: story.tags || [],
                        scroll: true
                    })
                ]
            }),
            filteredCharacter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_CharacterDetailCta, {
                character: filteredCharacter
            }),
            weeklySummaries && (weeklySummaries === null || weeklySummaries === void 0 ? void 0 : weeklySummaries.length) > 0 && !isExpiredStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(stories_SimpleStampRanking, {
                weeklySummary: weeklySummaries[0]
            }),
            isWaitfreeStory && !isExpiredStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Border/* default */.Z, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                        sizes: {
                            top: dist_esm/* Spacing.small */.Ki.small,
                            bottom: dist_esm/* Spacing.small */.Ki.small
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            css: waitfreeCSS,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                                    className: "align-middle",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(esm/* Trans */.cC, {
                                                t: t,
                                                i18nKey: "기다리면무료 무료회차 N회차",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                                                        children: {
                                                            freeEpisodeCount: story.freeEpisodeCount
                                                        }
                                                    }),
                                                    "회차까지 무료"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                            children: t("{{waitfreeDuration}}마다 무료", {
                                                waitfreeDuration: (0,date/* formatDuration */.LU)(story.waitfreeDuration)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                            className: "icon-btn",
                                            onClick: openWaitfreeInfoModal,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                                icon: icon/* QuestionCircle */.I1,
                                                size: dist_esm/* Sizes.small */.u8.small,
                                                color: theme.colors.main300
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    css: waitfreeProgressCSS,
                                    children: isWaitfreeReady(story, now) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                style: {
                                                    width: "".concat(100 - (0,date/* differenceInSeconds */.cA)(story.waitfreeReset, now) / story.waitfreeDuration * 100, "%")
                                                }
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                                                children: t("{{waitfreeDuration}} 남음", {
                                                    waitfreeDuration: (0,date/* formatDistance */.Bb)(story.waitfreeReset, now, {
                                                        addSuffix: false
                                                    })
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                                                children: t("준비됐어요!")
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_WaitfreeInfoModal, {
                        name: "waitfree-info-modal",
                        open: isWaitfreeInfoModalOpen,
                        waitfreeDuration: story.waitfreeDuration,
                        waitfreeBlockCount: story.waitfreeBlockCount,
                        onClose: closeWaitfreeInfoModal
                    })
                ]
            }),
            isExpiredStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: expiredCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _storyId_objectSpreadProps(_storyId_objectSpread({}, redFill), {
                        text: "라이센스 종료 안내"
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        children: t("해당 작품의 라이센스가 종료되어 소장한 회차만 볼 수 있어요.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: induceOfferwallCSS,
                onClick: function() {
                    return openOfferwall(webview/* OfferwallType.tnk */.TO.tnk);
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    children: !isExpiredStory && (story.hasBookedPublic || story.saleType === constants/* StorySaleType.standardWaitfree */.dn.standardWaitfree) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(esm/* Trans */.cC, {
                        t: t,
                        i18nKey: "오퍼월 유도 문구1",
                        children: [
                            "기다리지 말고 \uD83D\uDC49\uD83C\uDFFB",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                children: "여기서"
                            }),
                            " \uD83C\uDF88풍선 받으세요!"
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(esm/* Trans */.cC, {
                        t: t,
                        i18nKey: "오퍼월 유도 문구2",
                        children: [
                            "채티 생활의 필수템 \uD83C\uDF88",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("b", {
                                children: "풍선"
                            }),
                            " \uD83D\uDC49\uD83C\uDFFB",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                children: "여기서"
                            }),
                            " 받으세요!"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Adfit/* default */.Z, {
                type: "story"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Border/* default */.Z, {}),
            !isExpiredStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                    to: "/stories/".concat(story.id, "/donation-ranking"),
                    left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                        children: t("후원 랭킹")
                    }),
                    right: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("small", {
                        css: donationRankingTextCSS,
                        children: t("후원을 하면 작가님에게 큰 힘이 됩니다!")
                    })
                })
            }),
            !isExpiredStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Border/* default */.Z, {
                type: Border/* BorderType.space */.T.space
            }),
            !isExpiredStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                    text: story.latestRead && story.latestRead.episodeTitle ? t("{{episodeTitle}}부터 이어보기", {
                        episodeTitle: (0,misc/* ellipsisString */.PJ)(story.latestRead.episodeTitle, 15)
                    }) : t("첫화보기"),
                    type: "border",
                    onClick: handleContinueReadEpisode
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Border/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(stories_EpisodeList, {
                story: story
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ShareModal["default"], {
                name: "story-share-modal",
                open: isShareModalOpen,
                storyId: storyId,
                shareType: "story",
                episodeId: (ref5 = story.firstEpisode) === null || ref5 === void 0 ? void 0 : ref5.id,
                url: story.firstEpisode ? "/stories/".concat(story.id, "/episodes/").concat((ref6 = story.firstEpisode) === null || ref6 === void 0 ? void 0 : ref6.id) : undefined,
                title: story.title,
                summary: story.summary,
                imageUrl: story.coverImage.attachment.url,
                onClose: closeShareModal
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NotificationModal["default"], {
                name: "story-notification-modal",
                open: isNotificationModalOpen,
                objectType: constants/* SettingType.story */.Sd.story,
                objectId: storyId,
                settingKey: "newEpisodePushStatus",
                onClose: closeNotificationModal,
                notificationOption: notificationOption
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryBadgeInfoModal/* HonorPartnershipStoryInfoModal */.l, {
                name: "honor-partnership-story-info-modal",
                open: isHonorPartnershipStoryInfoModalOpen,
                onClose: closeHonorPartnershipStoryInfoModal
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_HonorApplicantModal, {
                name: "honor-partnership-applicant-info-modal",
                open: isHonorPartnershipApplicantInfoModalOpen,
                onClose: closeHonorPartnershipApplicantInfoModal
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryBadgeInfoModal/* OriginalStoryInfoModal */.h, {
                name: "original-story-info-modal",
                open: isOriginalStoryInfoModalOpen,
                onClose: closeOriginalStoryInfoModal
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryDonationModal, {
                name: "donation-modal",
                story: story,
                open: isDonationModalOpen,
                onClose: closeDonationModal
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_AppReviewModal, {
                name: "app-review-modal",
                open: isAppReviewModalOpen,
                onClose: closeAppReviewModal
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Push/* default */.Z, {
                size: Push/* PushSize.floatingButton */.z.floatingButton
            }),
            !isExpiredStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FloatingButtonArea/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(DonationButton/* default */.Z, {
                    onClick: openDonationModal
                })
            })
        ]
    });
};
/**
 * Page
 */ var StoryDetailPage = function() {
    var router = (0,next_router.useRouter)();
    var storyId = (0,utils_query/* getRouterQuery */.Fm)(router.query.storyId);
    (0,useScrollPosition/* useScrollPosition */.R)("storyDetail:".concat(storyId));
    (0,hook/* useScreen */.EV)("작품 상세");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Layout/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Suspense, {
            fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryDetailSkeleton/* default */.Z, {}),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SafeArea/* default */.Z, {
                bottom: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryDetail, {})
            })
        })
    });
};
var StoryDetailLoading = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Layout/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryDetailSkeleton/* default */.Z, {})
    });
};
var __N_SSP = true;
/* harmony default export */ var _storyId_ = ((0,auth/* withAuth */.QO)(StoryDetailPage, {
    isSignInRequired: false,
    LoadingComponent: StoryDetailLoading
}));


/***/ }),

/***/ 72315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useAutoPurchaseStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88766);

var useAutoPurchaseStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)(function(set) {
    return {
        autoPurchase: undefined,
        setAutoPurchase: function(storyId, purchaseType) {
            var isAutoApplyVoucher = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            set({
                autoPurchase: {
                    storyId: storyId,
                    purchaseType: purchaseType,
                    isAutoApplyVoucher: isAutoApplyVoucher
                }
            });
        },
        reset: function() {
            set({
                autoPurchase: undefined
            });
        }
    };
});


/***/ }),

/***/ 21784:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"present":"Present_present__dtncr","name":"Present_name__2U_0i","instruction":"Present_instruction__roqrM","rotate-container":"Present_rotate-container__m6tKO","present-rotate":"Present_present-rotate__3VYDJ","bottom":"Present_bottom__NXj3_","front":"Present_front__ud9br","left":"Present_left__QWTof","back":"Present_back__LiC82","right":"Present_right__2HNEf","lid-top":"Present_lid-top__nZHtJ","lid-front":"Present_lid-front__SLvp1","lid-left":"Present_lid-left__RI_Ic","lid-back":"Present_lid-back__ZHa11","lid-right":"Present_lid-right__I4oxE","lid":"Present_lid__57HZf","lid-animation":"Present_lid-animation__GE5Cu","open":"Present_open__6BBTp","canvas":"Present_canvas__w4_Rf","canvas-story":"Present_canvas-story__sbSzL"};

/***/ }),

/***/ 77814:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5277,1726,4514,741,8371,285,462,1119,738,4149,9774,2888,179], function() { return __webpack_exec__(84790); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);